var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./AwardsAcademyPopup.jinja');
require('./AwardsAcademyPopup.less');

var CommonSidebar = require('front/components/CommonSidebar/CommonSidebar');
var AwardsCommonWinnersList = require('front/components/AwardsCommonWinnersList/AwardsCommonWinnersList');

module.exports = BasePopup.extend({

    template: template,

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonSidebar': {selector: '.CommonSidebar', viewConstructor: CommonSidebar}
    },

    events: _.extend({
        'click .AwardsAcademyPopup-yearSelector': 'toggleYearDropdown'
    }, BasePopup.prototype.baseEvents),


    apiUrl: function () {
        return Urls['front:api:awards_academy-popup'](this.year, 'json');
    },

    renderData: function () {
        return {
            popup: this.data || {}
        };
    },


    initialize: function (options) {
        this.options = options || {};

        this.year = this.options.year;

        _.bindAll(this, 'onBodyClick');

        BasePopup.prototype.initialize.call(this, options);
    },


    toggleYearDropdown: function (e) {
        var $selector = this.$('.AwardsAcademyPopup-yearSelector');
        var dropdownClass = '.AwardsAcademyPopup-yearSelectorDropdown';
        var activeModifier = 'AwardsAcademyPopup-yearSelector--active';

        if ($(e.target).closest(dropdownClass).length) return;

        if ($selector.hasClass(activeModifier)) {
            $selector.find(dropdownClass).slideUp(200);
            $selector.removeClass(activeModifier);
            $('body').off('click', this.onBodyClick);
        } else {
            $selector.find(dropdownClass).slideDown(200);
            $selector.addClass(activeModifier);
            $('body').on('click', this.onBodyClick);
        }
    },


    onBodyClick: function (e) {
        if ($(e.target).closest('.AwardsAcademyPopup-yearSelector').length) return;

        this.toggleYearDropdown(e);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/AwardsAcademyPopup/AwardsAcademyPopup.js
// module id = 257
// module chunks = 0